import React from 'react';
import { Table } from 'semantic-ui-react';
import OnOffNoLabel from '../OnOffNoLabel';

const SingleSelectCell = ({
  label,
  checked,
  disabled,
  onClick,
}) => (
  <Table.Cell collapsing disabled={disabled} className="aridhia-single-select-cell">
    <OnOffNoLabel
      checked={checked}
      disabled={disabled}
      label={label}
      message="hidden.label.select"
      onClick={onClick}
      single
    />
  </Table.Cell>
);

export default SingleSelectCell;
